import { render, staticRenderFns } from "./ClientSkeleton.vue?vue&type=template&id=40cc15c6"
import script from "./ClientSkeleton.vue?vue&type=script&lang=js"
export * from "./ClientSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports